var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEchoLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 375 375",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e51039",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.815 6.507c-48.36 0-92.314 19.007-124.77 49.993 64.057 57.958 150.095 56.348 160.441 119.109 12.036 14.213 25.983 24.22 42.278 29.064 2.246-4.154 1.584-8.631 0-13.209 21.102 16.454 32.581 37.584 36.991 63.412-5.284-2.307-7.927-1.103-13.211 0-16.865 31.722-44.608 45.989-81.911 44.919-61.528-89.02-158.503-84.813-179.446-27.004 30.493 56.946 90.569 95.702 159.628 95.702 99.892 0 180.998-81.099 180.998-180.993 0-99.894-81.106-180.993-180.998-180.993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.063 180.894c-15.026-12.761-32.641-21.568-52.846-26.423l23.78 15.854c6.885 15.624 17.003 17.294 29.066 10.569"
  }))));
}
export default __webpack_public_path__ + "static/svg/echoLogo.svg";
export { SvgEchoLogo as ReactComponent };